// Mock still standing in for rephrase and source documents; the draft is real.
import { mockRephrase } from './fixtures';
import { AiSourceReference, RephraseActionKind } from './types';

const MOCK_LATENCY_MS = 1500;

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function rephraseText(
  text: string,
  action: RephraseActionKind,
): Promise<{ proposedText: string }> {
  await delay(MOCK_LATENCY_MS);
  return { proposedText: mockRephrase(text, action) };
}

export async function fetchSourceDocument(
  ref: AiSourceReference,
): Promise<Blob> {
  await delay(300);
  return new Blob(
    [
      `Mock source document\n\nTitle: ${ref.title}\nFilename: ${ref.filename}\n\nThis placeholder file stands in for the real document until the backend AI endpoints are available.`,
    ],
    { type: 'text/plain;charset=utf-8' },
  );
}
